import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import PopUp from 'src/components/design-system/PopUp';
import { informationIcon } from 'src/utils/icons';

const InformationComponent = () => (
  <div className="m-1 max-w-[400px] max-h-[300px] overflow-auto">
    <div className={`bg-blue-200 w-full rounded-md break-words text-wrap p-1 text-sm`}>
      <div className={`p-2 bg-blue-300 text-left font-bold rounded-md`}>
        Append Line Item Sequence Number
      </div>
      <ul className="text-left px-3 py-3 overflow-auto">
        <li className="whitespace-pre-wrap mb-2 list-item list-disc ml-4">
          When <b>enabled</b>, the system will automatically append the unique line item sequence
          number to the entered value.
        </li>
        <li className="whitespace-pre-wrap mb-2 list-item list-disc ml-4">
          Example: If you are adding 3 line items that will be line items 6, 7, and 8 on your
          invoice, and your Item # field value is the default value "Item", and you replace the
          Description field value of "Item" with "Contract Labor", the resulting lines would
          contain:
          <div className="flex gap-2">
            <div className="flex flex-col">
              <span className="font-bold">Item # </span>
              <span>Item 6</span>
              <span>Item 7</span>
              <span>Item 8</span>
            </div>
            <div className="flex flex-col">
              <span className="font-bold">Item Description</span>
              <span>Contract Labor 6</span>
              <span>Contract Labor 7</span>
              <span>Contract Labor 8</span>
            </div>
          </div>
        </li>
        <li className="whitespace-pre-wrap mb-2 list-item list-disc ml-4">
          When <b>disabled</b>, the system will only pass in the text supplied.
        </li>
        <li className="whitespace-pre-wrap mb-2 list-item list-disc ml-4">
          Example: If you are adding 3 line items that will be line items 6, 7, and 8 on your
          invoice, and your Item # field value is the default value "Item", and you replace the
          Description field value of "Item" with "Contract Labor", the resulting lines would
          contain:
          <div className="flex gap-2">
            <div className="flex flex-col">
              <span className="font-bold">Item # </span>
              <span>Item</span>
              <span>Item</span>
              <span>Item</span>
            </div>
            <div className="flex flex-col">
              <span className="font-bold">Item Description</span>
              <span>Contract Labor</span>
              <span>Contract Labor</span>
              <span>Contract Labor</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
);

const AppendSequenceHeaderCell = (props: GridHeaderCellProps) => (
  <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
    <div className="flex items-center gap-2">
      <div className="flex flex-col items-center">
        <span>Append Line Item </span>
        <span>Sequence Number</span>
      </div>
      <PopUp
        popupAlign={{ horizontal: 'center', vertical: 'top' }}
        anchorAlign={{ horizontal: 'left', vertical: 'bottom' }}
        content={<InformationComponent />}
        show={true}
      >
        <span className="cursor-pointer">{informationIcon}</span>
      </PopUp>
    </div>
  </th>
);

export default AppendSequenceHeaderCell;
